module.exports = __webpack_public_path__ + "static/media/8.55e2c8b1.png";